import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

import './tiered-radio-button-form.module.css';

type Props = {
    value?: boolean;
    name: string;
    trueLabel?: string;
    falseLabel?: string;
    onChange: (...args: any) => any;
};

export class FormBoolean extends React.Component<Props> {
    render() {
        return (
            <RadioGroup
                name={this.props.name}
                onChange={this.handleSelect}
                selectedValue={this.props.value !== undefined ? this.props.value.toString() : null}
            >
                <Radio value='true'>{this.props.trueLabel || 'is true'}</Radio>
                <Radio value='false'>{this.props.falseLabel || 'is false'}</Radio>
            </RadioGroup>
        );
    }

    handleSelect = (val: string) => {
        this.props.onChange({
            [this.props.name]: val,
        });
    };
}
